module.exports = __webpack_public_path__ + "img/nodejwt.png.52857d03.webp";